/*
 * Bundle & Save custom element.
 *
 * Renders up to TWO recommended products (NOT the current product) as stacked
 * cards, each with its own colour swatches and size buttons. Colour is
 * preselected; size is not. Each card is optional: pick a size to include that
 * product. Every included product is added to the cart as a SEPARATE line item
 * via a single /cart/add.js POST, then the cart drawer opens. The shown set
 * follows the page's selected variant through a variant -> [recommendation ids]
 * map (theme variantChange pub/sub event), falling back to a default list.
 */
(function () {
  if (typeof customElements === 'undefined' || customElements.get('bundle-save')) return;

  var ONE_SIZE = '__one__';

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function money(cents) {
    try {
      var formatted = theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
      var temp = document.createElement('div');
      temp.innerHTML = formatted;
      return temp.textContent || temp.innerText || formatted;
    } catch (e) {
      return '€ ' + (Number(cents || 0) / 100).toFixed(2).replace('.', ',');
    }
  }

  function imageWide(src, width) {
    if (!src) return src;
    var base = String(src).split('?')[0].trim();
    if (!base) return src;
    return base + '?width=' + width;
  }

  class BundleSave extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      this.sectionId = this.getAttribute('data-section-id');
      this.mainProductId = this.getAttribute('data-main-product-id');
      this.cardsContainer = this.querySelector('[data-bundle-cards]');
      this.submitButton = this.querySelector('[data-bundle-submit]');
      this.submitText = this.querySelector('[data-bundle-submit-text]');
      this.errorMessage = this.querySelector('.product-form__error-message');
      this.totalEl = this.querySelector('[data-bundle-total]');
      this.compareEl = this.querySelector('[data-bundle-compare]');
      this.badgeEl = this.querySelector('[data-bundle-badge]');

      this.recPool = {};
      var poolEls = this.querySelectorAll('[data-bundle-rec-pool]');
      for (var pi = 0; pi < poolEls.length; pi++) {
        try {
          var pd = JSON.parse(poolEls[pi].textContent);
          if (pd && pd.id != null) this.recPool[String(pd.id)] = pd;
        } catch (e) {}
      }

      this.defaultRecs = this.normIds(this.parseIsland('[data-bundle-default-recs]'));
      this.variantRecMap = this.parseIsland('[data-bundle-variant-rec-map]') || {};
      this.currentMainVariantId = this.getAttribute('data-main-initial-variant-id');

      this.currentRecIds = this.recIdsForVariant(this.currentMainVariantId);
      this.products = this.buildProducts(this.currentRecIds, []);

      if (!this.products.length || !this.cardsContainer) {
        this.hidden = true;
        return;
      }

      this.renderCards();
      this.updatePricing();

      if (this.submitButton) {
        this.submitButton.addEventListener('click', this.onSubmit.bind(this));
      }

      if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS && theme.pubsub.PUB_SUB_EVENTS.variantChange) {
        this._unsubscribe = theme.pubsub.subscribe(
          theme.pubsub.PUB_SUB_EVENTS.variantChange,
          this.onVariantChange.bind(this)
        );
      }
    }

    disconnectedCallback() {
      if (typeof this._unsubscribe === 'function') this._unsubscribe();
    }

    /* ----- data ----- */

    parseIsland(selector) {
      var el = this.querySelector(selector);
      if (!el) return null;
      try {
        return JSON.parse(el.textContent);
      } catch (e) {
        return null;
      }
    }

    normIds(arr) {
      if (!Array.isArray(arr)) return [];
      return arr
        .map(function (x) {
          return String(x);
        })
        .filter(function (x) {
          return x && x !== 'null' && x !== 'undefined';
        });
    }

    recIdsForVariant(variantId) {
      var ids = this.variantRecMap[String(variantId)];
      ids = this.normIds(ids);
      if (ids.length) return ids;
      return this.defaultRecs.slice();
    }

    sameIds(a, b) {
      if (!a || !b || a.length !== b.length) return false;
      for (var i = 0; i < a.length; i++) {
        if (String(a[i]) !== String(b[i])) return false;
      }
      return true;
    }

    buildProducts(ids, prev) {
      var self = this;
      prev = prev || [];
      var out = [];
      ids.forEach(function (id) {
        var data = self.recPool[String(id)];
        if (!data) return;
        var p = self.buildModel(data);
        var old = prev.filter(function (o) {
          return o && String(o.id) === String(id);
        })[0];

        var color = null;
        if (p.colorIdx >= 0) {
          if (old && old.colorValue && self.colorAvailable(p, old.colorValue)) {
            color = old.colorValue;
          } else {
            color = self.firstAvailableColor(p);
          }
        }
        p.colorValue = color;
        p.sizeValue = null;

        if (old && old.sizeValue) {
          if (p.sizeIdx < 0) {
            if (old.sizeValue === ONE_SIZE) p.sizeValue = ONE_SIZE;
          } else if (self.sizeAvailableForColor(p, old.sizeValue)) {
            p.sizeValue = old.sizeValue;
          }
        }
        out.push(p);
      });
      return out;
    }

    buildModel(data) {
      var options = Array.isArray(data.options) ? data.options : [];
      var variants = Array.isArray(data.variants) ? data.variants : [];
      var colorIdx = options.findIndex(function (o) {
        return o.isColor;
      });
      var sizeIdx = options.findIndex(function (o) {
        return o.isSize;
      });
      if (sizeIdx < 0) {
        sizeIdx = options.findIndex(function (o, i) {
          return i !== colorIdx;
        });
        if (sizeIdx >= 0) {
          var vals = options[sizeIdx].values || [];
          if (vals.length === 1 && vals[0] && vals[0].name === 'Default Title') sizeIdx = -1;
        }
      }
      return {
        id: data.id,
        title: data.title,
        url: data.url,
        fallbackImage: data.fallbackImage,
        initialOptions: data.initialOptions,
        sizeChartId: data.sizeChartId,
        options: options,
        variants: variants,
        colorIdx: colorIdx,
        sizeIdx: sizeIdx,
        colorValue: null,
        sizeValue: null
      };
    }

    /* ----- availability ----- */

    colorAvailable(p, color) {
      return p.variants.some(function (v) {
        return v.available && (p.colorIdx < 0 || v.options[p.colorIdx] === color);
      });
    }

    firstAvailableColor(p) {
      if (p.colorIdx < 0) return null;
      var opt = p.options[p.colorIdx];
      if (!opt) return null;
      for (var i = 0; i < opt.values.length; i++) {
        if (this.colorAvailable(p, opt.values[i].name)) return opt.values[i].name;
      }
      return opt.values[0] ? opt.values[0].name : null;
    }

    sizeAvailableForColor(p, sizeVal) {
      if (p.sizeIdx < 0) return true;
      return p.variants.some(function (v) {
        return (
          v.available &&
          (p.colorIdx < 0 || v.options[p.colorIdx] === p.colorValue) &&
          v.options[p.sizeIdx] === sizeVal
        );
      });
    }

    resolveVariant(p) {
      var cands = p.variants.filter(function (v) {
        return (
          (p.colorIdx < 0 || v.options[p.colorIdx] === p.colorValue) &&
          (p.sizeIdx < 0 || p.sizeValue == null || p.sizeValue === ONE_SIZE || v.options[p.sizeIdx] === p.sizeValue)
        );
      });
      var avail = cands.filter(function (v) {
        return v.available;
      });
      return avail[0] || cands[0] || null;
    }

    displayVariant(p) {
      var v = this.resolveVariant(p);
      return v || p.variants[0] || null;
    }

    // The variant for the current colour + a specific size value (prefers an
    // available one). Used to flag which individual sizes are pre-order so each
    // size pill can carry the same "Pre-order" badge as the product page picker.
    sizeVariant(p, sizeVal) {
      var cands = p.variants.filter(function (v) {
        return (
          (p.colorIdx < 0 || v.options[p.colorIdx] === p.colorValue) &&
          (p.sizeIdx < 0 || sizeVal === ONE_SIZE || v.options[p.sizeIdx] === sizeVal)
        );
      });
      var avail = cands.filter(function (v) {
        return v.available;
      });
      return avail[0] || cands[0] || null;
    }

    preorderBadgeHtml() {
      var label = this.getAttribute('data-preorder-label') || 'Pre-order';
      return '<span class="preorder-badge" aria-hidden="true">' + escapeHtml(label) + '</span>';
    }

    isComplete(p) {
      if (!p.sizeValue) return false;
      var v = this.resolveVariant(p);
      return !!(v && v.available);
    }

    anyComplete() {
      var self = this;
      return this.products.some(function (p) {
        return self.isComplete(p);
      });
    }

    /* ----- rendering ----- */

    renderCards() {
      var self = this;
      this.cardsContainer.innerHTML = this.products
        .map(function (p, i) {
          return self.cardHtml(p, i);
        })
        .join('');
      this.products.forEach(function (p, i) {
        self.wireCard(i);
        self.updateColorName(i);
        self.updateSizes(i);
        self.updateCardImage(i);
      });
    }

    cardHtml(p, i) {
      var colorOpt = p.colorIdx >= 0 ? p.options[p.colorIdx] : null;
      var self = this;

      var swatchHtml = '';
      var colorLabel = '';
      if (colorOpt) {
        colorLabel =
          '<div class="bundle-card__opt-label bundle-card__opt-label--color">' +
          escapeHtml(colorOpt.name) +
          ': <span data-color-name></span></div>';
        swatchHtml =
          '<div class="bundle-card__swatches" data-swatches>' +
          colorOpt.values
            .map(function (val) {
              var avail = self.colorAvailable(p, val.name);
              var hasSwatch = val.swatchImage || val.swatchColor;
              if (hasSwatch) {
                var style = val.swatchImage
                  ? 'background-image:url(' + escapeHtml(val.swatchImage) + ')'
                  : 'background-color:' + escapeHtml(val.swatchColor);
                return (
                  '<button type="button" class="bundle-swatch' +
                  (avail ? '' : ' is-soldout') +
                  '" style="' +
                  style +
                  '" data-color="' +
                  escapeHtml(val.name) +
                  '" title="' +
                  escapeHtml(val.name) +
                  '" aria-pressed="false"><span class="sr-only">' +
                  escapeHtml(val.name) +
                  '</span></button>'
                );
              }
              return (
                '<button type="button" class="bundle-pill' +
                (avail ? '' : ' is-soldout') +
                '" data-color="' +
                escapeHtml(val.name) +
                '" aria-pressed="false">' +
                escapeHtml(val.name) +
                '</button>'
              );
            })
            .join('') +
          '</div>';
      }

      var sizesHead = '';
      if (p.sizeIdx >= 0) {
        var sizeName = p.options[p.sizeIdx].name;
        var sizechart = '';
        if (p.sizeChartId) {
          sizechart =
            '<button type="button" class="link bundle-card__sizechart" aria-controls="' +
            escapeHtml(p.sizeChartId) +
            '" aria-expanded="false">' +
            escapeHtml(this.getAttribute('data-size-chart-label') || 'Maattabel') +
            '</button>';
        }
        sizesHead =
          '<div class="bundle-card__sizes-head"><span class="bundle-card__opt-label">' +
          escapeHtml(sizeName) +
          '</span>' +
          sizechart +
          '</div>';
      }

      return (
        '<div class="bundle-card" data-card="' +
        i +
        '">' +
        // Media + info row. The photo stretches to this row's height (= the info
        // column up to the LAST size button); the pre-order note is moved OUT of
        // the row (a sibling below it) so it never lengthens the photo.
        '<div class="bundle-card__row">' +
        '<div class="bundle-card__media">' +
        '<img data-card-img alt="" loading="lazy">' +
        // Selection indicator on the photo itself (top-left): a calm empty circle
        // that fills green with a white check once this card has a size chosen.
        // No text — the circle does the work. setCardStatus toggles .is-selected.
        '<span class="bundle-card__check" data-card-status aria-hidden="true"></span>' +
        '</div>' +
        '<div class="bundle-card__body">' +
        '<div class="bundle-card__head">' +
        '<a class="bundle-card__title" href="' +
        escapeHtml(p.url || '#') +
        '">' +
        escapeHtml(p.title || '') +
        '</a>' +
        '<span class="bundle-card__price" data-card-price></span>' +
        '</div>' +
        colorLabel +
        swatchHtml +
        sizesHead +
        '<div class="bundle-card__sizes" data-sizes></div>' +
        '</div>' + // .bundle-card__body
        '</div>' + // .bundle-card__row
        // Pre-order note (same look + delivery date as the product page). Sits
        // BELOW the media+body row, full width, so it extends the card downward
        // without lengthening the photo. Hidden until the chosen/displayed variant
        // for this card is a pre-order.
        '<p class="preorder-note bundle-card__preorder-note" data-preorder-note hidden></p>' +
        '</div>' // .bundle-card
      );
    }

    cardEl(i) {
      return this.cardsContainer.querySelector('[data-card="' + i + '"]');
    }

    wireCard(i) {
      var self = this;
      var card = this.cardEl(i);
      if (!card) return;
      card.querySelectorAll('[data-color]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var val = btn.getAttribute('data-color');
          var p = self.products[i];
          if (!self.colorAvailable(p, val)) return;
          if (p.colorValue === val) return;
          p.colorValue = val;
          if (p.sizeIdx >= 0 && p.sizeValue && !self.sizeAvailableForColor(p, p.sizeValue)) {
            p.sizeValue = null;
          }
          self.updateSwatches(i);
          self.updateColorName(i);
          self.updateSizes(i);
          self.updateCardImage(i);
          self.updatePricing();
        });
      });
    }

    updateSwatches(i) {
      var p = this.products[i];
      var card = this.cardEl(i);
      if (!card) return;
      card.querySelectorAll('[data-color]').forEach(function (btn) {
        var active = btn.getAttribute('data-color') === p.colorValue;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    updateColorName(i) {
      var p = this.products[i];
      var card = this.cardEl(i);
      if (!card) return;
      var span = card.querySelector('[data-color-name]');
      if (span) span.textContent = p.colorValue || '';
    }

    updateSizes(i) {
      var self = this;
      var p = this.products[i];
      var card = this.cardEl(i);
      if (!card) return;
      var cont = card.querySelector('[data-sizes]');
      if (!cont) return;

      if (p.sizeIdx < 0) {
        var oneActive = p.sizeValue === ONE_SIZE;
        var oneVar = this.sizeVariant(p, ONE_SIZE);
        var onePre = !!(oneVar && oneVar.preorder);
        // Round 22: a pre-order one-size variant stays selectable (it is oversold
        // with continue selling, so oneVar.available is true) and keeps its badge;
        // only a genuinely sold-out one-size variant is struck + not selectable.
        var oneAvail = !!(oneVar && oneVar.available);
        cont.innerHTML =
          '<button type="button" class="bundle-pill' +
          (oneActive ? ' is-active' : '') +
          (onePre ? ' is-preorder' : '') +
          (oneAvail ? '' : ' is-soldout') +
          '" data-size="' +
          ONE_SIZE +
          '"' +
          (oneAvail ? '' : ' aria-disabled="true"') +
          '>' +
          escapeHtml(this.getAttribute('data-one-size-label') || 'Eén maat') +
          (onePre ? this.preorderBadgeHtml() : '') +
          '</button>';
        cont.querySelectorAll('[data-size]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            if (!oneAvail) return;
            p.sizeValue = p.sizeValue === ONE_SIZE ? null : ONE_SIZE;
            self.updateSizes(i);
            self.updateCardImage(i);
            self.updatePricing();
          });
        });
        return;
      }

      var opt = p.options[p.sizeIdx];
      cont.innerHTML = opt.values
        .map(function (val) {
          var avail = self.sizeAvailableForColor(p, val.name);
          var active = p.sizeValue === val.name;
          // A pre-order variant is still "available" (oversold with continue
          // selling), so it stays selectable and only gets the "Pre-order" badge.
          var sv = self.sizeVariant(p, val.name);
          var isPre = !!(sv && sv.preorder);
          return (
            '<button type="button" class="bundle-pill' +
            (active ? ' is-active' : '') +
            (isPre ? ' is-preorder' : '') +
            (avail ? '' : ' is-soldout') +
            '" data-size="' +
            escapeHtml(val.name) +
            '"' +
            (avail ? '' : ' aria-disabled="true"') +
            '>' +
            escapeHtml(val.name) +
            (isPre ? self.preorderBadgeHtml() : '') +
            '</button>'
          );
        })
        .join('');
      cont.querySelectorAll('[data-size]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var val = btn.getAttribute('data-size');
          if (!self.sizeAvailableForColor(p, val)) return;
          p.sizeValue = p.sizeValue === val ? null : val;
          self.updateSizes(i);
          self.updateCardImage(i);
          self.updatePricing();
        });
      });
    }

    updateCardImage(i) {
      var p = this.products[i];
      var card = this.cardEl(i);
      if (!card) return;
      var img = card.querySelector('[data-card-img]');
      if (!img) return;
      var v = this.displayVariant(p);
      var src = (v && v.image) || p.fallbackImage;
      if (!src) return;
      var next = imageWide(src, 600);
      if (img.getAttribute('src') !== next) img.setAttribute('src', next);
      img.setAttribute('alt', p.title || '');
    }

    /* ----- pricing ----- */

    updatePricing() {
      var self = this;
      var anyComplete = this.anyComplete();
      var priceTotal = 0;
      var compareTotal = 0;
      var anyCompare = false;

      var completeCount = 0;

      this.products.forEach(function (p, i) {
        var v = self.displayVariant(p);
        var price = v ? v.price : 0;
        // Real Shopify "on sale" rule: a compare-at price only counts when it is
        // strictly higher than the price the customer actually pays.
        var compare = v && v.compareAtPrice && v.compareAtPrice > price ? v.compareAtPrice : 0;
        var complete = self.isComplete(p);
        if (complete) completeCount += 1;
        var included = anyComplete ? complete : true;
        if (included) {
          priceTotal += price;
          compareTotal += compare > 0 ? compare : price;
          if (compare > 0) anyCompare = true;
        }
        // Each card shows the product's real prices: compare-at struck through
        // with the actual price next to it (exactly like the product page), or
        // just the normal price when there is no compare-at price.
        self.setCardPrice(i, price, compare, v);
        // Selection indicator (Amazon-style): filled check + "Toegevoegd" once
        // this card has a size, empty circle + "Kies een maat" until then. Both
        // cards always stay at full brightness — no dimming.
        self.setCardStatus(i, complete);
        // Pre-order note (same indication + delivery date as the product page):
        // shown whenever the variant currently displayed for this card (colour +
        // chosen size, else the colour's first available variant) is a pre-order.
        self.setCardPreorder(i, v);
      });

      var savings = anyCompare ? Math.max(0, compareTotal - priceTotal) : 0;

      if (savings > 0) {
        if (this.compareEl) {
          this.compareEl.textContent = money(compareTotal);
          this.compareEl.hidden = false;
        }
        if (this.totalEl) this.totalEl.textContent = money(priceTotal);
        if (this.badgeEl) {
          this.badgeEl.textContent = (this.getAttribute('data-save-label') || 'Bespaar') + ' ' + money(savings);
          this.badgeEl.hidden = false;
        }
      } else {
        if (this.compareEl) this.compareEl.hidden = true;
        if (this.totalEl) this.totalEl.textContent = money(priceTotal);
        if (this.badgeEl) this.badgeEl.hidden = true;
      }

      this.bundleTotal = priceTotal;
      this.bundleSavings = savings;
      this.updateSubmit(completeCount);
    }

    setCardPrice(i, price, compare, v) {
      var card = this.cardEl(i);
      if (!card) return;
      var el = card.querySelector('[data-card-price]');
      if (!el) return;
      if (compare > price) {
        el.innerHTML =
          '<s class="bundle-card__price-was">' + escapeHtml(money(compare)) + '</s>' +
          '<span class="bundle-card__price-now">' + escapeHtml(money(price)) + '</span>';
      } else {
        el.innerHTML = '<span class="bundle-card__price-now">' + escapeHtml(money(price)) + '</span>';
      }
      // Creatorcode-korting (cc-creator-code.js): de getoonde variant en prijs doorgeven,
      // zodat daar de prijs met kortingscode (derde prijs) bij gezet kan worden.
      el.classList.remove('cc-active');
      el.removeAttribute('data-cc-sig');
      if (v && v.id) {
        el.setAttribute('data-cc-variant', v.id);
        el.setAttribute('data-cc-price', price);
        el.setAttribute('data-cc-compare', compare || 0);
      } else {
        el.removeAttribute('data-cc-variant');
      }
    }

    setCardStatus(i, selected) {
      var card = this.cardEl(i);
      if (!card) return;
      var el = card.querySelector('[data-card-status]');
      if (el) el.classList.toggle('is-selected', !!selected);
    }

    setCardPreorder(i, v) {
      var card = this.cardEl(i);
      if (!card) return;
      var note = card.querySelector('[data-preorder-note]');
      if (!note) return;
      if (v && v.preorder) {
        var attention = this.getAttribute('data-preorder-attention-label') || 'Let op:';
        var label = this.getAttribute('data-preorder-label') || 'Pre-order';
        var delivery = this.getAttribute('data-preorder-delivery-label') || 'Verwachte levering rond';
        var klarna =
          this.getAttribute('data-preorder-klarna-label') ||
          'Voor een probleemloze afhandeling, bij voorkeur geen Klarna bij pre-orders.';
        var html = '<strong>' + escapeHtml(attention) + '</strong> ' + escapeHtml(label) + '.';
        if (v.preorderDate) html += ' ' + escapeHtml(delivery) + ' ' + escapeHtml(v.preorderDate) + '.';
        if (klarna) html += ' ' + escapeHtml(klarna);
        note.innerHTML = html;
        note.hidden = false;
      } else {
        note.hidden = true;
        note.innerHTML = '';
      }
    }

    updateSubmit(completeCount) {
      if (!this.submitButton) return;
      var enabled = completeCount > 0;
      this.submitButton.disabled = !enabled;

      var main;
      if (!enabled) {
        // Nothing chosen yet: one calm prompt.
        main = this.getAttribute('data-select-size-label') || 'Selecteer een maat';
      } else if (completeCount === 1) {
        // Exactly one product chosen: single-item label + that product's price
        // (bundleTotal equals the one included product's price here).
        main =
          (this.getAttribute('data-add-label-single') || 'Artikel toevoegen') +
          ' · ' +
          money(this.bundleTotal);
      } else {
        // Both chosen: bundle label + total.
        main =
          (this.getAttribute('data-add-label') || 'Beide toevoegen') +
          ' · ' +
          money(this.bundleTotal);
      }

      // Single-line button: only the dynamic main label. We set the inner text
      // span so the hover-button's .btn-fill overlay is never wiped.
      if (this.submitText) {
        this.submitText.textContent = main;
      } else {
        this.submitButton.textContent = main;
      }
    }

    /* ----- sync with the page variant picker ----- */

    onVariantChange(event) {
      var d = event && event.data;
      if (!d) return;
      if (String(d.sectionId) !== String(this.sectionId)) return;
      if (String(d.productId) !== String(this.mainProductId)) return;
      var variant = d.variant;
      if (!variant || variant.id == null) return;

      this.currentMainVariantId = variant.id;
      var newRecIds = this.recIdsForVariant(variant.id);
      // The page picker fires variantChange on EVERY option click (incl. size),
      // so only rebuild when the recommended set actually changes. This preserves
      // the shopper's per-card colour/size selections on unrelated clicks.
      if (this.sameIds(newRecIds, this.currentRecIds)) return;

      this.currentRecIds = newRecIds;
      this.products = this.buildProducts(newRecIds, this.products);
      if (!this.products.length) {
        this.cardsContainer.innerHTML = '';
        this.updatePricing();
        return;
      }
      this.renderCards();
      this.updatePricing();
    }

    /* ----- submit ----- */

    handleErrorMessage(message) {
      if (!this.errorMessage) return;
      this.errorMessage.toggleAttribute('hidden', !message);
      this.errorMessage.textContent = message || '';
    }

    onSubmit(event) {
      if (event) event.preventDefault();
      if (!this.anyComplete()) return;
      if (this.submitButton.hasAttribute('aria-disabled')) return;

      var bundleId = Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);

      var self = this;
      var items = [];
      this.products.forEach(function (p, i) {
        if (!self.isComplete(p)) return;
        var v = self.resolveVariant(p);
        if (!v) return;
        var properties = {
          _bundle_id: bundleId,
          _bundle_index: String(i + 1)
        };
        // Pre-order line item: send the same customer-facing property the native
        // buy button + pack builder send so the order shows the expected delivery.
        if (v.preorder) {
          properties['Pre-order'] = v.preorderDate
            ? 'Wordt rond ' + v.preorderDate + ' uitgeleverd'
            : 'Wordt zo snel mogelijk uitgeleverd';
        }
        items.push({
          id: v.id,
          quantity: 1,
          properties: properties
        });
      });

      if (!items.length) return;

      var redirectToCart =
        document.body.classList.contains('template-cart') ||
        (theme.settings && theme.settings.cartType === 'page');

      this.handleErrorMessage();
      this.activeElement = (event && event.submitter) || this.submitButton;

      var sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle }
        })
      );

      var body = JSON.stringify({
        items: items,
        sections: sectionsToBundle,
        sections_url: window.location.pathname
      });

      this.submitButton.setAttribute('aria-disabled', 'true');
      this.submitButton.setAttribute('aria-busy', 'true');

      fetch(theme.routes.cart_add_url, { ...theme.utils.fetchConfig('javascript'), body: body })
        .then(function (response) {
          return response.json();
        })
        .then(async function (parsedState) {
          if (parsedState.status) {
            self.handleErrorMessage(parsedState.description);
            document.dispatchEvent(
              new CustomEvent('ajaxProduct:error', {
                detail: { errorMessage: parsedState.description }
              })
            );

            var failCart = await (
              await fetch(theme.routes.cart_url, { ...theme.utils.fetchConfig('json', 'GET') })
            ).json();

            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
              source: 'bundle-save',
              cart: failCart
            });

            document.dispatchEvent(
              new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } })
            );

            return;
          }

          var cartJson = await (
            await fetch(theme.routes.cart_url, { ...theme.utils.fetchConfig('json', 'GET') })
          ).json();

          cartJson.sections = parsedState.sections;

          theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
            source: 'bundle-save',
            cart: cartJson
          });

          document.dispatchEvent(
            new CustomEvent('ajaxProduct:added', { detail: { product: parsedState } })
          );

          if (redirectToCart) {
            window.location.href = theme.routes.cart_url;
            return;
          }

          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.show === 'function') {
            drawer.show(self.activeElement);
          }

          self.products.forEach(function (p, i) {
            p.sizeValue = null;
            self.updateSizes(i);
            self.updateCardImage(i);
          });
          self.updatePricing();
        })
        .catch(function () {
          self.handleErrorMessage(
            self.getAttribute('data-error-label') || 'Er ging iets mis. Probeer het opnieuw.'
          );
        })
        .finally(function () {
          self.submitButton.removeAttribute('aria-busy');
          self.submitButton.removeAttribute('aria-disabled');
        });
    }
  }

  customElements.define('bundle-save', BundleSave);
})();
